import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { MdOutlineEdit } from "react-icons/md"
import { updateCategoryCount } from "../../../Redux/Slices/styleProcureCountSlice"
import Popup from "../../../component/Popup"

const StyleProcureCountUpdate = ({ gender, category }) => {
  const [total, setTotal] = useState(0)
  const dispatch = useDispatch();
  const styleProcureCounts = useSelector(state => state.styleProcureCounts)
  const [showTable, setShowTable] = useState(false)

  useEffect(() => {
    setTotal(prev => {
      return Object.keys(styleProcureCounts).filter(g => g == gender).reduce((prev, current) => {
        return prev + Object.keys(styleProcureCounts[current]).reduce((p, c) => {
          return p + styleProcureCounts[current][c]
        }, 0)
      }, 0)
    })
  }, [styleProcureCounts, gender])

  const updateCount = (e) => {
    const targetId = e.target.id
    const parts = targetId.split('__');
    const gender = parts[0]
    const category = parts[1]
    const updatedValue = e.target.value
    const newValue = updatedValue.length == 0 ? 0 : parseInt(updatedValue.trim())
    if (isNaN(newValue)) {
      return
    }
    dispatch(updateCategoryCount({ gender, category, count: newValue }))
  }

  return <div className="pl-4 flex text-sm font-medium">
    <p>I am planning to procure {styleProcureCounts[gender] && styleProcureCounts[gender].hasOwnProperty(category) ? styleProcureCounts[gender][category] : total} unique {styleProcureCounts[gender] && styleProcureCounts[gender][category] ? category : (gender == 'M' ? `men's` : `women's`)} styles:</p>    <button className="px-1" onClick={() => setShowTable(true)}><MdOutlineEdit size={20} /></button>
    {showTable ? <Popup isPopUp={showTable} setIsPopUp={() => {
      setShowTable(false)
    }}>
      <div className={""}>
        <div>
          <p className="font-medium flex">I am planning to procure {styleProcureCounts[gender] && styleProcureCounts[gender].hasOwnProperty(category) ? <input
            className=" rounded border-b-2 bg-slate-50 focus:border-slate-200 focus:bg-slate-100 mx-1 border p-1 w-min outline-none"
            id={`${gender}__${category}`}
            value={styleProcureCounts[gender][category]}
            onChange={updateCount}
          /> : total} unique {styleProcureCounts[gender] && styleProcureCounts[gender].hasOwnProperty(category) ? category : (gender == 'M' ? `men's` : `women's`)} styles:</p>
          {styleProcureCounts[gender] && styleProcureCounts[gender].hasOwnProperty(category) ? <div>

          </div>
            : <div className="w-full flex ">
              {['F', 'M'].filter(g => g == gender).map(gender => <div className="w-full shrink-0 p-2 text-center" key={gender}>
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="border-2 ">
                      <th className="pl-6 text-left" colSpan={2}>FOR {gender == 'F' ? 'WOMEN' : 'MEN'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(styleProcureCounts[gender])
                      .sort((a, b) => styleProcureCounts[gender][b] - styleProcureCounts[gender][a])
                      .map(category => <tr key={category} >
                        <td className="border-2 w-2/3  py-1">{category}</td>
                        <td className="border-2 py-1">
                          <input
                            className="w-4/5 rounded border-b-2 border-white focus:border-slate-200 focus:bg-slate-50 p-2 outline-none"
                            id={`${gender}__${category}`}
                            value={styleProcureCounts[gender][category]}
                            onChange={updateCount}
                          />
                        </td>
                      </tr>)}
                    <tr>
                      <td className="font-semibold border-2 bg-slate-100 p-2">Total</td>
                      <td className="border-2 bg-slate-100 p-2">{Object.values(styleProcureCounts[gender]).reduce((prev, current) => prev + current, 0)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>)}
            </div>
          }
        </div>
      </div>

    </Popup> : null}
  </div>
}

export default StyleProcureCountUpdate
